import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {

  static targets = [
    "donutChart"
  ]

  static values = {
    dataValues: { type: Array },
    colors: { type: Array },
    labels: { type: Array },
    legendIcon: { type: Array },
    legendPosition: { type: String },
    legendTitle: { type: String, default: "" },
    showTotal: { type: Boolean, default: true },
    showLegendValues: { type: Boolean, default: true },
    showTooltip: { type: Boolean, default: true },
    showLegend: { type: Boolean, default: true },
  }

  connect() {
    let iconValues = this.legendIconValue.map ((x) => function() {return x})
    let format_if_numeric = (value) => {
      return !isNaN(value) ? new Intl.NumberFormat("en-US").format(value) : value
    }
    let showLegendValues = this.showLegendValuesValue
    let customLegendFormatter = (seriesName, opts) => {
      if (showLegendValues) {
        return `
          <div class="flex justify-between items-center w-full">
            <div class="legend-item-label ml-2">${seriesName}</div>
            <div class="legend-item-value min-w-[35px] text-right">${format_if_numeric(opts.w.globals.series[opts.seriesIndex])}</div>
          </div>
        `
      } else {
        return `<div class="legend-item-label ml-2">${seriesName}</div>`
      }
    }

    this.chartOptions = {
      series: this.dataValuesValue,
      colors: this.colorsValue,
      chart: {
        height: "100%",
        width: "100%",
        type: "donut",
      },
      stroke: {
        colors: ["var(--color-donut-chart-segment-border)"],
        show: true,
        width: 2,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: this.showTotalValue,
              name: {
                show: this.showTotalValue,
                offsetY: 20,
              },
              total: {
                show: this.showTotalValue,
                label: "Total",
                color: "var(--color-gray-500)",
                formatter: function (w) {
                  let total_value = w.globals.seriesTotals.reduce((a, b) => { return a + b }, 0)
                  return format_if_numeric(total_value)
                },
              },
              value: {
                show: this.showTotalValue,
                color: "var(--color-gray-500)",
                offsetY: -20,
                formatter: format_if_numeric,
              },
            },
            size: "60%",
          },
        },
      },
      labels: this.labelsValue,
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        enabled: this.showTooltipValue,
        fillSeriesColor: false,
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          const formatted_value = format_if_numeric(series[seriesIndex])

          return (
            "<div class='ml-2 mr-1 flex flex-row items-center'><div class='icon-solid icon-before icon-circle' style='color:" + w.globals.colors[seriesIndex] + "'></div><span style='padding: 5px'>" +
            w.globals.labels[seriesIndex] +
            ": " +
            formatted_value +
            "</span></div>"
          )
        }
      },
      legend: {
        show: this.showLegendValue,
        position: this.legendPositionValue,
        formatter: (seriesName, opts) => {
          return customLegendFormatter(seriesName, opts)
        },
        itemMargin: {
          horizontal: 0,
          vertical: 4,
        },
        markers: {
          size: 8,
          customHTML: iconValues
        },
      },
    }

    this.chart = new ApexCharts(this.donutChartTarget, this.chartOptions)
    this.chart.render().then(() => {
      if (this.legendTitleValue) {
        const legend = this.donutChartTarget.querySelector(".apexcharts-legend")
        if (legend) {
          const titleEl = document.createElement("div")
          titleEl.className = "apexcharts-legend-title"
          titleEl.textContent = this.legendTitleValue
          legend.prepend(titleEl)
        }
      }
    })
  }

  disconnect() {
    this.chart.destroy()
  }
}
